import product1 from "./products/1.jpg";
import product2 from "./products/2.jpeg";
import product3 from "./products/3.png";
import product4 from "./products/4.png";
import product5 from "./products/5.jpeg";
import product6 from "./products/6.jpeg";
import product7 from "./products/7.jpeg";
import product8 from "./products/8.webp";


export const PRODUCTS =[
   {
      id : 1,
      productName:"Hoodie",
      price: 59.0,
      productImage:product1,
   },
   {
      id : 2,
      productName:"Sweatshirt",
      price: 79.0,
      productImage:product2,
   },
   {
      id : 3,
      productName:"Jogger",
      price: 89.0,
      productImage:product3,
   },
   {
      id : 4,
      productName:"T-Shirt",
      price: 45.0,
      productImage:product4,
   },
   {
      id : 5,
      productName:"IPhone",
      price: 1299.0,
      productImage:product5,
   },
   {
      id : 6,
      productName:"Mac-BookPro",
      price: 1799.0,
      productImage:product6,
   },
   {
      id : 7,
      productName:"Shoes",
      price: 129.0,
      productImage:product7,
   },
   {
      id : 8,
      productName:"Leather-Shoes",
      price: 169.0,
      productImage:product8,
   },
];